var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":_vm.chipColor.color,"dark":_vm.chipColor.dark,"small":_vm.small,"label":_vm.label}},[(_vm.icon)?_c('v-icon',{attrs:{"small":_vm.small,"left":""}},[_vm._v(" mdi-timer ")]):_vm._e(),(!_vm.chipColor.disable)?[_vm._v(" "+_vm._s(_vm._f("sec2date")(_vm.time))+" ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }